module.exports = __webpack_public_path__ + "static/media/filename (6).35842819.png";